/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { SuggestNewSupplierForm } from './SuggestNewSupplierForm';
import { SuggestNewSupplierModalForm } from './SuggestNewSupplierModalForm';

export { SuggestNewSupplierForm, SuggestNewSupplierModalForm };
